import { SALESEXECUTIVE_LIST, SALESEXECUTIVE_DETAILS } from './../constant/ActionTypes';

export const salesexecutiveReducer = (state, action) => {
    switch (action.type) {
        case SALESEXECUTIVE_LIST:
            return { ...state, salesexecutiveList: action.payload };
        case SALESEXECUTIVE_DETAILS:
            return { ...state, salesexecutiveDetails: action.payload };
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./contexts/reducer/salesexecutiveReducer.js